import { categories } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
            <div className="lg:col-span-4">
              <h2 className="font-heading text-4xl md:text-5xl font-black text-background-50 tracking-tight">
                ITAOBUY
              </h2>
              <p className="mt-5 text-background-50/60 text-sm leading-relaxed max-w-sm">
                Il portale italiano dedicato a Itaobuy Spreadsheet. Guide, categorie prodotti e risorse per aiutarti a trovare ciò che cerchi in modo semplice e veloce.
              </p>
              <div className="flex items-center gap-3 mt-6">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
                  <i className="ri-pinterest-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-sm"></i>
                </a>
              </div>
            </div>

            <div className="lg:col-span-4">
              <div className="space-y-6">
                <div>
                  <p className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-2">Indirizzo</p>
                  <p className="text-sm text-background-50/70">Via dello Shopping 42</p>
                  <p className="text-sm text-background-50/70">20121 Milano, Italia</p>
                </div>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-2">Contatti</p>
                  <p className="text-sm text-background-50/70">info@itaobuyspread.bond</p>
                </div>
                <div>
                  <p className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-2">Link Rapidi</p>
                  <div className="flex flex-wrap gap-x-6 gap-y-2">
                    <button onClick={() => navigate('/')} className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Home</button>
                    <button onClick={() => document.getElementById('guide')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Guide</button>
                    <button onClick={() => document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' })} className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Categorie</button>
                    <button onClick={() => navigate('/articoli/itaobuy-spreadsheet-guida-completa')} className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">Blog</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:col-span-4">
              <p className="text-xs font-semibold uppercase tracking-widest text-background-50/40 mb-3">Categorie Popolari</p>
              <div className="flex flex-wrap gap-2">
                {categories.slice(0, 8).map((cat) => (
                  <a
                    key={cat.id}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="inline-block px-3 py-1.5 rounded-full border border-background-50/15 text-xs text-background-50/70 hover:text-background-50 hover:border-background-50/30 transition-colors whitespace-nowrap"
                  >
                    {cat.nameIt}
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} itaobuyspread.bond - Tutti i diritti riservati.
            </p>
            <div className="flex items-center gap-6">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap">
                kaspreadsheet.com
              </a>
              <button onClick={() => navigate('/articoli/itaobuy-spreadsheet-guida-completa')} className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors whitespace-nowrap cursor-pointer">
                Guida Completa
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}